module.exports = __webpack_public_path__ + "media/fart-01.d7021412.mp3";